import { Link } from "react-router-dom";
const logoImage = '/logo.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-primary/15 bg-surface-1/70 mt-auto">
      {/* Top hairline accent */}
      <span aria-hidden className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />

      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-6">
        {/* Top row: brand + condensed nav */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-4 border-b border-border">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 group">
            <span className="relative w-[28px] h-[28px] flex items-center justify-center">
              <span aria-hidden className="absolute inset-0 bg-primary/25 blur-[8px] opacity-60 group-hover:opacity-100 transition-opacity" />
              <span aria-hidden className="absolute inset-0 border border-primary/40 clip-corner-mark" />
              <img
                src={logoImage}
                alt="LOWKEYX"
                width={22}
                height={22}
                className="relative object-contain w-[22px] h-[22px] drop-shadow-[0_0_6px_hsl(var(--primary)/0.6)]"
                loading="lazy"
                decoding="async"
              />
            </span>
            <span className="font-display text-[15px] tracking-[0.18em]">
              LOWKEY<span className="text-primary">X</span>
            </span>
          </Link>

          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-[10px] uppercase tracking-[0.18em]">
            <Link to="/arsenal" className="text-muted-foreground hover:text-primary transition-colors">Herramientas</Link>
            <Link to="/knowledge" className="text-muted-foreground hover:text-primary transition-colors">Knowledge</Link>
            <Link to="/conciencia" className="text-muted-foreground hover:text-primary transition-colors">Conciencia</Link>
            <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">About</Link>
            <Link to="/legal" className="text-muted-foreground hover:text-primary transition-colors">Legal</Link>
          </nav>
        </div>

        {/* Bottom row: copyright + status */}
        <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-2 pt-3 font-mono text-[9px] uppercase tracking-[0.16em] text-muted-foreground/80">
          <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>© {currentYear} <span className="text-primary">LOWKEYX</span></span>
            <span className="text-border">·</span>
            <span>build by <span className="text-foreground/70">Speatx</span></span>
          </span>
          <span className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-signal-green intel-pulse-green" />
              <span>operational</span>
            </span>
            <span className="text-border">|</span>
            <span className="text-foreground/60">v3.1</span>
          </span>
        </div>
      </div>
    </footer>
  );
};